export const THEME_CONFIG = {
  /** Numeric Rem value  */
  grid: {
    gridGutterWidth_desktop: 1.5, // 24px
    gridGutterWidth_mobile: 1, // 16px
    gridFullWidth: 76.5, // 1224px
    gridMinWidth: 20, // 320px
    gridColumns: {
      desktop: 12,
      tablet: 4,
      mobile: 2,
    },
  },
  /**
   * Calculated with: https://type-scale.com/?size=18&scale=1.200&text=A%20Visual%20Type%20Scale&font=Poppins&fontweight=400&bodyfont=body_font_default&bodyfontweight=400&lineheight=1.75&backgroundcolor=%23ffffff&fontcolor=%23000000&preview=false
   * Base size: 16
   * Mobile scale: 1.125
   * Desktop scale: 1.2
   */
  fontSize: {
    root: "16px",
    h0_desktop: 6.5, // 104px
    h0_mobile: 4, // 72px

    h1_desktop: 6.5, // 104px
    h1_mobile: 4, // 72px

    h2_desktop: 5, // 80px
    h2_mobile: 3.25, // 52px

    h3_desktop: 4, // 64px
    h3_mobile: 2.5, // 40px

    h4_desktop: 3.25, // 52px
    h4_mobile: 2, // 32px

    h5_desktop: 2.5, // 40px
    h5_mobile: 1.5, // 24px

    h6_desktop: 2, // 32px
    h6_mobile: 1.125, // 18px

    body_xl_desktop: 1.5, // 24px
    body_xl_mobile: 1, // 16px

    body_lg_desktop: 1.125, // 18px
    body_lg_mobile: 1.125, // 18px

    body_md_desktop: 1, // 16px (root)
    body_md_mobile: 1, // 16px (root)

    body_sm_desktop: 0.875, // 14px
    body_sm_mobile: 0.875, // 14px

    body_xs_desktop: 0.75, // 12px
    body_xs_mobile: 0.75, // 12px

    body_xxs_desktop: 0.625, // 12px
    body_xxs_mobile: 0.625, // 12px

    code_desktop: 0.833, // 13.32px
    code_mobile: 0.833, // 15.01px
  },

  phoneMockup: {
    phoneMinWidth: 16.25, // 260 px
    phoneMaxWidth: 18.5, // 296 px
  },
} as const;
